<div *ngIf="sellsListings.length > 0" class="card mb-lg-4">
  <div class="card-header">
    <ng-container *ngTemplateOutlet="itemCardHeaderTemplate"></ng-container>
  </div>

  <div class="card-body">
    <div class="listings flex-wrap">
      <ng-container *ngTemplateOutlet="itemCardBodyTemplate"></ng-container>
    </div>
  </div>

  <div class="card-footer flex-row">
    <fa-icon (click)="infoButtonClicked()" icon="info-circle"></fa-icon>
    <fa-icon (click)="removeButtonClicked()" icon="times"></fa-icon>
  </div>
</div>

<div *ngIf="pairsWellListings.length > 0" class="card mb-lg-4">
  <div class="card-header">
    <ng-container *ngTemplateOutlet="pairsWellCardHeaderTemplate"></ng-container>
  </div>

  <div class="card-body">
    <div class="listings flex-wrap">
      <ng-container *ngTemplateOutlet="pairsWellCardBodyTemplate"></ng-container>
    </div>
  </div>

  <div class="card-footer flex-row">
    <fa-icon (click)="infoButtonClicked()" icon="info-circle"></fa-icon>
    <fa-icon (click)="removeButtonClicked()" icon="times"></fa-icon>
  </div>
</div>

<div *ngIf="listings.brandListings?.length > 0" class="card">
  <div class="card-header">
    <ng-container *ngTemplateOutlet="brandCardHeaderTemplate"></ng-container>
  </div>

  <div class="card-body">
    <div class="listings flex-wrap">
      <ng-container *ngTemplateOutlet="brandCardBodyTemplate"></ng-container>
    </div>
  </div>

  <div class="card-footer flex-row">
    <fa-icon (click)="infoButtonClicked()" icon="info-circle"></fa-icon>
    <fa-icon (click)="removeButtonClicked()" icon="times"></fa-icon>
  </div>
</div>

<ng-template #loadingTemplate>
  <astrobin-loading-indicator></astrobin-loading-indicator>
</ng-template>

<ng-template #cardHeaderItemListingsFullTemplate>
  <span [innerHTML]="'From our sponsors' | translate"></span>
</ng-template>

<ng-template #cardHeaderItemListingsLiteTemplate>
  <span [innerHTML]="'Known stock availability for' | translate"></span>
</ng-template>

<ng-template #cardHeaderItemListingsPairsWellFullTemplate>
  <span [innerHTML]="'Pair well with this' | translate"></span>
</ng-template>

<ng-template #cardHeaderItemListingsPairsWellLiteTemplate>
  <span [innerHTML]="'Equipment that pairs well with this' | translate"></span>
</ng-template>

<ng-template #cardHeaderBrandListingsFullTemplate>
  <span [innerHTML]="'From our sponsors' | translate"></span>
</ng-template>

<ng-template #cardHeaderBrandListingsLiteTemplate>
  <span [innerHTML]="'Known stock availability' | translate"></span>
</ng-template>

<ng-template #cardBodyItemListingsFullTemplate>
  <div *ngFor="let listing of listings.itemListings" class="listing">
    <ng-container [ngTemplateOutlet]="listingFull" [ngTemplateOutletContext]="{ listing }"></ng-container>
  </div>
</ng-template>

<ng-template #cardBodyItemListingsLiteTemplate>
  <!-- TODO -->
</ng-template>

<ng-template #cardBodyBrandListingsFullTemplate>
  <div *ngFor="let listing of listings.brandListings" class="listing">
    <ng-container [ngTemplateOutlet]="listingFull" [ngTemplateOutletContext]="{ listing }"></ng-container>
  </div>
</ng-template>

<ng-template #cardBodyBrandListingsLiteTemplate>
  <!-- TODO -->
</ng-template>

<ng-template #cardBodyItemListingsPairsWellFullTemplate>
  <div *ngFor="let listing of pairsWellListings" class="listing">
    <ng-container [ngTemplateOutlet]="listingFull" [ngTemplateOutletContext]="{ listing }"></ng-container>
  </div>
</ng-template>

<ng-template #cardBodyItemListingsPairsWellLiteTemplate>
  <!-- TODO -->
</ng-template>

<ng-template #listingFull let-listing="listing">
  <ng-container *ngIf="!!listing.retailer.logo || !!listing.imageUrl; else noLogoTemplate">
    <a
      [href]="urlWithTags(listing)"
      [ngbTooltip]="listing.retailer.name"
      class="with-logo"
      astrobinGtagOutboundClickEvent
      target="_blank"
    >
      <img *ngIf="listing.imageUrl" [alt]="listing.name" [src]="listing.imageUrl" />
      <img *ngIf="!listing.imageUrl" [alt]="listing.retailer.name" [src]="listing.retailer.logo" />
    </a>

    <div *ngIf="!!listing.stockStatus" class="stock-status">
      <astrobin-stock-status [listing]="listing"></astrobin-stock-status>
    </div>
  </ng-container>

  <ng-template #noLogoTemplate>
    <a [href]="urlWithTags(listing)" astrobinGtagOutboundClickEvent target="_blank">
      {{ listing.retailer.name }}
    </a>
  </ng-template>
</ng-template>
